import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../gd-components/base-component/base-component";

import SelectTaskType from "../../gd-ui/select-task-type/select-task-type";

import Form from 'src/core/gd-form/form/form-modal-new/form-modal-new';
import FormManager from 'src/core/gd-form/common/form-manager';
import FormRow from "./form-row";
import TaskStatusSelector_v2 from "../../gd-ui/select-status/task_v2/task-new";

class ModalEditTask extends BaseComponent {

    static propTypes = {
        task: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired
    };

    state = {
        taskTypeId: null
    };

    constructor(props) {
        super(props);

        const initFormData = {
            taskType: props.task.taskTypeId
        };

        const formStructure = {
            fields: {
                taskType: {
                    type: 'select',
                    isRequired: true,
                    onUserChange: this.onTaskTypeSelected
                },
                taskStatus: {
                    type: 'select',
                    isRequired: false,
                    label: 'Task Status'
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onTaskTypeSelected = () => {
        this.form.setFieldIsRequired('taskStatus',true);
        this.form.setValue('taskStatus',null);

        this.setState({
            taskTypeId: this.form.getValue('taskType')
        })
    };

    onStatusSelected = (value) => {
        this.form.setValue('taskStatus',value);
    };

    onSubmit = (result) => {
        this.props.onSubmit(result);
    };

    render() {
        const projectId = this.props.task.projectId ? this.props.task.projectId : this.props.task.parentId;

        // great idea ... !
        const taskCopy = _.cloneDeep(this.props.task)
        taskCopy.taskTypeId     = this.state.taskTypeId
        taskCopy.statusId       = null

        return (
            <Form form={this.form} submitLabel="Save" >
                <div className="tbl">
                    <FormRow title="Task Type" form={this.form} name="taskType">
                        <SelectTaskType form={this.form}
                                        name="taskType"
                                        multiselect={false}
                                        projectId={projectId}
                                        renderValue="form"
                                        canHaveNoValue={false} />
                    </FormRow>

                    {this.state.taskTypeId &&
                    <FormRow title="Status" form={this.form} name="taskStatus">


                        <TaskStatusSelector_v2 task={taskCopy}
                                    renderValue="form"
                                    targetOffset="-46 0"
                                    attachmentType="vertical"
                                    onUserSelect={this.onStatusSelected} />

                    </FormRow>}
                </div>
            </Form>
        );
    }
}

module.exports = ModalEditTask;